import { useTheme } from "@mui/material";
import { Mail, MessageSquareText, Phone } from "lucide-react";
import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	handleEmailClick,
	handlePhoneClick,
	handleSmsClick,
} from "web_myplann/Shared/Utils/openExternalApps";

export const useActivityMenuItems = (agentDetail?: AgentDetailResponseDTO) => {
	const { t } = useResource();
	const theme = useTheme();

	return [
		{
			icon: <Phone size={16} color={theme.palette.grey[700]} />,
			label: t(Resources.Common.ToolbarMenu.Call),
			onClick: () => handlePhoneClick(agentDetail?.phone ?? undefined),
		},
		{
			icon: <MessageSquareText size={16} color={theme.palette.grey[700]} />,
			label: t(Resources.Common.ToolbarMenu.WriteSMS),
			onClick: () => handleSmsClick(agentDetail?.phone ?? undefined),
		},
		{
			icon: <Mail size={16} color={theme.palette.grey[700]} />,
			label: t(Resources.Common.ToolbarMenu.WriteEmail),
			onClick: () => handleEmailClick(agentDetail?.email ?? undefined),
		},
	];
};
